// Using a different naming convention to avoid conflicts
const DeleteIcon = ({
  width = '24',
  height = '24',
  className = '',
  title = '',
  stroke = '1.5',
  role = ''
}): React.ReactNode => {
  const hidden = title && title.length > 0 ? false : true;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden={`${hidden}`}
      role={role ? role : hidden ? 'graphics-document' : 'img'}
    >
      {!hidden && <title>{title}</title>}
      <path
        d="M2 5.6366H22"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M14.0454 2H9.95446C9.5928 2 9.24595 2.14367 8.99022 2.3994C8.73449 2.65513 8.59082 3.00198 8.59082 3.36364V5.63636H15.409V3.36364C15.409 3.00198 15.2653 2.65513 15.0096 2.3994C14.7539 2.14367 14.407 2 14.0454 2Z"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M9.95453 17.2275V10.4093"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M14.0455 17.2275V10.4093"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M18.2364 20.7457C18.2111 21.0873 18.0573 21.4067 17.8059 21.6395C17.5546 21.8723 17.2244 22.0012 16.8818 22.0002H7.11818C6.77561 22.0012 6.4454 21.8723 6.19406 21.6395C5.94273 21.4067 5.78893 21.0873 5.76364 20.7457L4.5 5.6366H19.5L18.2364 20.7457Z"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
    </svg>
  );
};

export default DeleteIcon;
